"use strict";

exports.__esModule = true;
exports.c_pagination__nav_page_select_c_form_control_width_chars = {
  "name": "--pf-c-pagination__nav-page-select--c-form-control--width-chars",
  "value": "2",
  "var": "var(--pf-c-pagination__nav-page-select--c-form-control--width-chars)"
};
exports["default"] = exports.c_pagination__nav_page_select_c_form_control_width_chars;